/**
 * Devnet network URL
 */
export const DEVNET_NETWORK_URL = 'https://devnet.fuel.network/v1/graphql';

/**
 * Testnet network URL
 */
export const TESTNET_NETWORK_URL = 'https://testnet.fuel.network/v1/graphql';
